import { useEffect, useState } from "react";
import { X } from "lucide-react";

const KEY = "perizia_privacy_accepted_v2";
const PRIVACY_URL = "https://www.periziafirma.it/privacy-policy/";
const COOKIE_URL = "https://www.periziafirma.it/cookie-policy/";

export default function PrivacyBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined" && !localStorage.getItem(KEY)) {
      setVisible(true);
    }
  }, []);
  if (!visible) return null;
  const accept = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 border hairline bg-white shadow-lg p-5" data-testid="privacy-banner">
      <div className="flex items-start justify-between gap-3">
        <div className="overline">Cookie & Privacy</div>
        <button onClick={() => setVisible(false)} className="text-slate-400 hover:text-ink" aria-label="chiudi">
          <X size={16} />
        </button>
      </div>
      <p className="mt-2 text-sm text-slate-700 leading-relaxed">
        Perizia Ready utilizza cookie tecnici essenziali per la sessione di autenticazione e per il salvataggio locale
        della compilazione. Nessun profilo pubblicitario, nessuna cessione a terzi.
        Per il dettaglio consulta l'informativa completa.
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={accept} data-testid="privacy-accept"
          className="bg-navy hover:bg-navy-dark text-white px-4 py-2 rounded-sm text-xs font-medium transition-colors">
          Ho letto e accetto
        </button>
        <a href={PRIVACY_URL} target="_blank" rel="noreferrer"
          className="text-xs px-4 py-2 border hairline hover:border-navy rounded-sm" data-testid="banner-privacy-link">
          Privacy Policy
        </a>
        <a href={COOKIE_URL} target="_blank" rel="noreferrer"
          className="text-xs px-4 py-2 border hairline hover:border-navy rounded-sm" data-testid="banner-cookie-link">
          Politica sui cookie
        </a>
      </div>
    </div>
  );
}
